import { render, staticRenderFns } from "./SocialPosting.vue?vue&type=template&id=2c32f0bd&scoped=true"
import script from "./SocialPosting.vue?vue&type=script&lang=js"
export * from "./SocialPosting.vue?vue&type=script&lang=js"
import style0 from "./SocialPosting.vue?vue&type=style&index=0&id=2c32f0bd&prod&lang=css"
import style1 from "./SocialPosting.vue?vue&type=style&index=1&id=2c32f0bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32f0bd",
  null
  
)

export default component.exports